export const ACTIVITIES_ACTION_PREFIX = 'ACTIVITIES';
export const ACTIVITIES_FILTER_KEY = 'activities';
